import { render, staticRenderFns } from "./Cobranca.vue?vue&type=template&id=49f91f50&"
import script from "./Cobranca.vue?vue&type=script&lang=js&"
export * from "./Cobranca.vue?vue&type=script&lang=js&"
import style0 from "./Cobranca.vue?vue&type=style&index=0&id=49f91f50&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports